import React, { useContext, useState } from 'react';
import CreateOrder from '../../components/orders/createOrder';
import OrderForm from '../../components/orders/orderForm';
import OrderForm2 from '../../components/orders/orderForm2';
import { OrderContext } from '../../context/orderContext';
import { useAddOrder } from '../../hooks/useOrders';
import { notification } from 'antd';

const NewOrder = () => {
    const { details, address } = useContext(OrderContext);
    const [api, contextHolder] = notification.useNotification();
    const [orderDetails, setOrderDetails] = details;

    const onSuccess = data => {
        setOrderDetails({
            company: '',
            services: [],
        });
        api['success']({
            message: ' Order placed successfully ',
        });
    };

    const onError = data => {
        if (data.response.data.message)
            api['error']({
                message: data.response.data.message,
            });
    };

    const { mutate: addOrder, isLoading } = useAddOrder(onSuccess, onError);

    const createOrder = data => {
        addOrder(data);
    };

    const createOrderSelf = data => {
        addOrder(data);
    };

    return (
        <div className="addOrder-main w-100">
            {contextHolder}
            {orderDetails?.company == '' ? <CreateOrder /> : <OrderForm2 createOrder={createOrder} loading={isLoading} />}
        </div>
    );
};

export default NewOrder;
